/**
 * Page Container
 */

import { WithRouter, withRouter } from 'found';
import * as React from 'react';
import { Helmet } from 'react-helmet';

import PageTemplate, { PageTemplateProps } from '../components/templates/Page';

interface IOwnProps extends PageTemplateProps {
  noIndex?: boolean;
}

type PageContainerProps = IOwnProps & WithRouter;

const PageContainer: React.SFC<PageContainerProps> = ({ children, noIndex, ...templateProps }) => (
  <PageTemplate {...templateProps}>
    <Helmet>
      {noIndex && <meta name="robots" content="noindex" />}
    </Helmet>
    {children}
  </PageTemplate>
);

export default withRouter<IOwnProps>(PageContainer);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/containers/Page.tsx